import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
function loadMetaPixel() {
  const w = window as any;
  if (w.fbq) return;
  const n: any = w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  w.fbq('init', '1344645667803652');
  w.fbq('track', 'PageView');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=1344645667803652&ev=PageView&noscript=1';
  document.body.appendChild(img);
}
function loadUtmifyPixel() {
  const w = window as any;
  if (w.__utmifyLoaded) return;
  w.__utmifyLoaded = true;
  w.pixelId = '6a4c0c4bd3e51ec9fbbbb389';
  const a = document.createElement('script');
  a.setAttribute('async', '');
  a.setAttribute('defer', '');
  a.setAttribute('src', 'https://cdn.utmify.com.br/scripts/pixel/pixel.js');
  document.head.appendChild(a);
}
function loadUtmifyUtms() {
  const w = window as any;
  if (w.__utmifyUtmsLoaded) return;
  w.__utmifyUtmsLoaded = true;
  const s = document.createElement('script');
  s.setAttribute('src', 'https://cdn.utmify.com.br/scripts/utms/latest.js');
  s.setAttribute('data-utmify-prevent-xcod-sck', '');
  s.setAttribute('data-utmify-prevent-subids', '');
  s.setAttribute('async', '');
  s.setAttribute('defer', '');
  document.head.appendChild(s);
}
function addPreconnect(href: string, crossOrigin?: boolean) {
  if (document.querySelector(`link[rel="preconnect"][href="${href}"]`)) return;
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  if (crossOrigin) link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
}
export function App() {
  useEffect(() => {
    // Preconnect to image CDN early — speeds up LCP by ~100-300ms on cold loads
    addPreconnect('https://cdn.magicpatterns.com', true);
    // Defer analytics pixel — load when browser is idle to reduce main thread work
    const loadPixels = () => {
      loadMetaPixel();
      loadUtmifyPixel();
      loadUtmifyUtms();
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadPixels, {
        timeout: 3500
      });
    } else {
      setTimeout(loadPixels, 2000);
    }
  }, []);
  return <LandingPage data-id="element-0" />;
}